export const INIT_BOOKING_PAGE = 'INIT_BOOKING_PAGE';
export const INIT_BOOKING_PAGE_SUCCESS = 'INIT_BOOKING_PAGE_SUCCESS';
export const INIT_BOOKING_PAGE_ERROR = 'INIT_BOOKING_PAGE_ERROR';
export const GET_BOOKING_REQUEST = 'GET_BOOKING_REQUEST';
export const GET_BOOKING_SUCCESS = 'GET_BOOKING_SUCCESS';
export const GET_BOOKING_ERROR = 'GET_BOOKING_ERROR';
export const SWITCH_BOOKING_ACTIVE = 'SWITCH_BOOKING_ACTIVE';
export const SORT_BOOKING_LIST = 'SORT_BOOKING_LIST';
export const SET_FILTERS = 'SET_FILTERS';
